enum RelationSubject {
  Patient = "Patient",
  PatientTriggerEvent = "Patient::Trigger::Event",
  Medium = "Medium",
  Ecg = "Patient::Measurement::Ecg",
  ProgramComponent = "Programm::Component"
}

export {
  RelationSubject
};
